var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.888 18.1292C29.888 25.7868 23.68 31.9958 16.0213 31.9958C8.36266 31.9958 2.15466 25.7868 2.15466 18.1292C2.15466 10.8311 7.79626 4.86305 14.9547 4.31585V2.12918H13.888V-0.00415039H18.1547V2.12918H17.088V4.31585C20.2219 4.55585 23.0645 5.83372 25.2704 7.80705L26.688 6.38945L28.8213 8.52918L27.2832 10.0673C28.9141 12.3404 29.888 15.1159 29.888 18.1292ZM16.0213 6.39692C9.54133 6.39692 4.288 11.6502 4.288 18.1302C4.288 24.6102 9.54133 29.8625 16.0213 29.8625C22.5013 29.8625 27.7547 24.6102 27.7547 18.1302C27.7547 11.6492 22.5013 6.39692 16.0213 6.39692Z",
    fill: "#08A693"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5255 19.5256C13.6928 18.6929 13.6928 17.3413 14.5255 16.5086C15.3582 15.6759 16.7098 15.6759 17.5425 16.5086C18.3752 17.3413 18.3752 18.6929 17.5425 19.5256L17.5425 27.0681L16.034 27.0681L14.8166 19.7639C14.7148 19.6908 14.616 19.6161 14.5255 19.5256Z",
    fill: "#08A693"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_1126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumTime);
export default __webpack_public_path__ + "static/media/mediumTime.29a82d3d5ea3c4e543c0693b05d6a471.svg";
export { ForwardRef as ReactComponent };